<template functional>
    <div class="tile-content tile-content-secondary">
        <p>Guess payment card expiration attempts up to 3 guesses at a new expiration date (based on an analysis of likely variations).</p>
        <p>For each guess, it tries to do a $1 authorization. If it is successful, the customer's payment collection card will be updated to use that card. The $1 authorization will be voided.</p>
    </div>
</template>

<script>
    export default {
        name: 'guess-payment-card-expiration',
    };
</script>
